import AuthService from '../services/auth.service';
import { AppPermissions } from '../constants/Permissions';

export const canReadDevice = AuthService.hasPermission(AppPermissions.Device.Read);
export const canReadPairing = AuthService.hasPermission(AppPermissions.Pairing.Read);
export const canReadVisit = AuthService.hasPermission(AppPermissions.Visit.Read);
export const canReadSightingProcessed = AuthService.hasPermission(AppPermissions.SightingProcessed.Read);
